module.exports = __webpack_public_path__ + "public/images/purple_arrow.f10a9c2531be26fba9fcd24dc347311b.webp";